var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Tiêu đề")]),_c('v-text-field',{attrs:{"rounded":"","outlined":""},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_c('v-row',{staticClass:"align-center justify-center ma-0 pt-5"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.save}},[_vm._v("Lưu thông tin ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }